import { render, staticRenderFns } from "./projectOrderDetail.vue?vue&type=template&id=7a679af1&scoped=true"
import script from "./projectOrderDetail.vue?vue&type=script&lang=js"
export * from "./projectOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./projectOrderDetail.vue?vue&type=style&index=0&id=7a679af1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a679af1",
  null
  
)

export default component.exports